"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m17.9873 7.9013-7.6608-4.425a3.5498 3.5498 0 0 0-3.552 6.147l4.1143 2.3761 4.213 2.4322-4.2132-2.4322-4.1143 2.3761a3.5502 3.5502 0 0 0-1.2982 4.8502 3.5505 3.5505 0 0 0 4.8502 1.2982l7.6636-4.4251-.0025-.0014c3.1518-1.8207 3.1518-6.3741-.0001-8.196zm-7.0987 4.0982 7.0985 4.0994-8.3352-3.3844 1.2367-.715z"
  })];
};

exports.default = _default;